import Dictionary from "./Dictionary";
import './Dictionary.scss';

export default Dictionary;